import { CONTACT_FORM_ROUTE, ESTIMATE_FORM_ROUTE, NEWSLETTER_FORM_ROUTE, ORDER_FORM_ROUTE, APPLICATION_FORM_ROUTE } from "../utils/api/routes";
import { query } from "./CommonService";

export default class FormService {
  static async sendContactForm({ currentData }) {
    return await query({ url: CONTACT_FORM_ROUTE, method: "POST", currentData });
  }

  static async sendEstimateForm({ currentData }) {
    return await query({ url: ESTIMATE_FORM_ROUTE, method: "POST", currentData });
  }

  static async sendSubscribeForm({ currentData }) {
    return await query({ url: NEWSLETTER_FORM_ROUTE, method: "POST", currentData });
  }

  static async sendOrderForm({ currentData }) {
    return await query({ url: ORDER_FORM_ROUTE, method: "POST", currentData });
  }

  static async sendApplicationForm({ currentData }) {
    return await query({ url: APPLICATION_FORM_ROUTE, method: "POST", currentData });
  }
}
